import FormatCurrency from 'components/Common/FormatCurrency'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  benefitValue: number
}

function LandingPageLoyaltyTravelShootCreditBenefitsModal(props: Props) {
  const { image, benefitValue } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Pro photos on your trip" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <VerticalSpacer gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="travelshoot_credit" />
            <BodyText variant="large">
              Make the memories last. Use your Travelshoot voucher to book a professional photo session at your destination—perfect for couples, families, or solo travellers.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Book a professional photoshoot at your holiday destination through Travelshoot.<br /><br />
                Choose your location, match with a local photographer, and capture unforgettable moments with a one-hour shoot.{' '}
                Within 48 hours you’ll receive a couple sneak peeks and the full album within 7 days.<br /><br />
                Use your <FormatCurrency value={benefitValue} format="dynamic" /> voucher at checkout and receive{' '}
                a gallery of professionally edited photos to keep forever.<br /><br />
                A Travelshoot can be booked on its own (doesn't need to be attached to a hotel booking){' '}
                and our friendly customer service team can organise your voucher post-booking.
              </BodyText>
            </VerticalSpacer>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTravelShootCreditBenefitsModal
